import {
  IMaterialDataTableItem, TDynamicDataTableItemDictionary, TValidContentTypes
} from '../prop-types';

const EMPTY_ROWS: IMaterialDataTableItem<TValidContentTypes>[] = [];

export const reduceCells = (
  cells: TDynamicDataTableItemDictionary<TValidContentTypes[]>
): IMaterialDataTableItem<TValidContentTypes>[] => {
  return cells.reduce(
    (acc, ri): IMaterialDataTableItem<TValidContentTypes>[] => [...acc, ri],
    EMPTY_ROWS
  );
};
